import React, { useEffect, useState } from 'react'
import {
  ContactContainer,
  Desktop,
  Mobile,
  TextContainer
} from '@/styles/pages/contact'

import Public from '@/helpers/PageTypes/Public'
import { useWindowSize } from '@/contexts/WindowSizeContext'

import SEO from '@/components/SEO'
import HeaderUnsigned from '@/components/LandingPage/Header'
import FooterUnsigned from '@/components/LandingPage/Footer'
import EmailButton from '@/components/EmailButton'

import { EVENT_KEYS } from '@/services/events'
import { LOCAL_KEYS } from '@/services/browserStorage'
import { ASSET_PATHS, PAGE_PATHS } from '@/services/paths'
import { COUNTRIES, getNormalizedLanguage } from '@/services/language'

import { useTranslation } from 'react-i18next'

const Contact = () => {
  const { t } = useTranslation()
  const { windowSize } = useWindowSize()

  const [pageTitle, setPageTitle] = useState(' | Contact')
  const [subtitlesSales, setSubtitlesSales] = useState('')
  const [labelsDepartment, setLabelsDepartment] = useState('')
  const [labelsFullName, setLabelsFullName] = useState('')
  const [labelsMobile, setLabelsMobile] = useState('')
  const [labelsEmail, setLabelsEmail] = useState('')
  const [labelsCountry, setLabelsCountry] = useState('')
  const [labelsProfession, setLabelsProfession] = useState('')
  const [labelsInstitution, setLabelsInstitution] = useState('')
  const [labelsIsAfya, setLabelsIsAfya] = useState('')
  const [labelsMessage, setLabelsMessage] = useState('')
  const [placeholdersDepartment, setPlaceholdersDepartment] = useState('')
  const [placeholdersName, setPlaceholdersName] = useState('')
  const [placeholdersPhone, setPlaceholdersPhone] = useState('')
  const [placeholdersEmail, setPlaceholdersEmail] = useState('')
  const [placeholdersCountry, setPlaceholdersCountry] = useState('')
  const [placeholdersProfession, setPlaceholdersProfession] = useState('')
  const [placeholdersInstitution, setPlaceholdersInstitution] = useState('')
  const [placeholdersMessage, setPlaceholdersMessage] = useState('')
  const [buttonsSend, setButtonsSend] = useState('')
  const [labelsContactWhats, setLabelsContactWhats] = useState('Whatsapp')
  const [labelsContactEmail, setLabelsContactEmail] = useState('Email')
  const [language, setLanguage] = useState()
  const [formID, setFormID] = useState()
  const [whatsAppLink, setWhatsAppLink] = useState('')

  useEffect(() => {
    setPageTitle(` | ${t('titles.contact')}`)
    setSubtitlesSales(t('subtitles.sales'))
    setLabelsDepartment(t('labels.department'))
    setLabelsFullName(t('labels.fullName'))
    setLabelsMobile(t('labels.mobile'))
    setLabelsEmail(t('labels.email'))
    setLabelsCountry(t('labels.country'))
    setLabelsProfession(t('labels.profession'))
    setLabelsInstitution(t('labels.institution'))
    setLabelsIsAfya(t('labels.isAfya'))
    setLabelsMessage(t('labels.message'))
    setPlaceholdersDepartment(t('placeholders.departmentSelect'))
    setPlaceholdersName(t('placeholders.name'))
    setPlaceholdersPhone(t('placeholders.phone'))
    setPlaceholdersEmail(t('placeholders.email'))
    setPlaceholdersCountry(t('placeholders.countrySelect'))
    setPlaceholdersProfession(t('placeholders.professionSelect'))
    setPlaceholdersInstitution(t('placeholders.institution'))
    setPlaceholdersMessage(t('placeholders.message'))
    setButtonsSend(t('buttons.send'))
    setLabelsContactWhats(t('labels.contactWhats'))
    setLabelsContactEmail(t('labels.contactEmail'))
  }, [t])

  useEffect(() => {
    setLanguage(
      getNormalizedLanguage(localStorage.getItem(LOCAL_KEYS.client_language))
    )
    const listener = document.addEventListener(
      EVENT_KEYS.languageChange,
      () => {
        setLanguage(
          getNormalizedLanguage(
            localStorage.getItem(LOCAL_KEYS.client_language)
          )
        )
      }
    )
    return () => {
      document.removeEventListener(EVENT_KEYS.languageChange, listener)
    }
  }, [])

  useEffect(() => {
    if (!language) return
    hideForm()

    switch (language) {
      case COUNTRIES.BR.lang:
        window.cfields = {
          112: 'setor_de_atendimento_do_contato_pt',
          113: 'pertence_ao_grupo_afya_contato_pt',
          108: 'telefone_celular',
          109: 'country',
          56: 'profisso',
          5: 'site_contact_message_ptbr'
        }
        setFormID('_form_31_')
        break

      case COUNTRIES.US.lang:
        window.cfields = {
          117: 'setor_de_atendimento_do_contato_en',
          115: 'pertence_ao_grupo_afya_contato_en',
          108: 'telefone_celular',
          111: 'country_bioatlas_en',
          69: 'occupation',
          5: 'site_contact_message_ptbr'
        }
        setFormID('_form_32_')
        break

      case COUNTRIES.ES.lang:
        window.cfields = {
          116: 'setor_de_atendimento_do_contato_es',
          114: 'pertence_ao_grupo_afya_contato_es',
          108: 'telefone_celular',
          110: 'country_bioatlas_es',
          62: 'profesin',
          5: 'site_contact_message_ptbr'
        }
        setFormID('_form_33_')
        break
    }
  }, [language])

  useEffect(() => {
    if (!formID) return
    showForm()

    window._show_thank_you = function (id, message, trackcmp_url, email) {
      var form = document.getElementById('_form_' + id + '_'),
        thank_you = form.querySelector('._form-thank-you')
      form.querySelector('._form-content').style.display = 'none'
      thank_you.innerHTML = message
      thank_you.style.display = 'block'
      const vgoAlias =
        typeof visitorGlobalObjectAlias === 'undefined'
          ? 'vgo'
          : visitorGlobalObjectAlias
      var visitorObject = window[vgoAlias]
      if (email && typeof visitorObject !== 'undefined') {
        visitorObject('setEmail', email)
        visitorObject('update')
      } else if (typeof trackcmp_url != 'undefined' && trackcmp_url) {
        // Site tracking URL to use after inline form submission.
        _load_script(trackcmp_url)
      }
      if (typeof window._form_callback !== 'undefined')
        window._form_callback(id)

      window.location = PAGE_PATHS.contact_success
    }

    window._show_error = function (id, message, html) {
      var form = document.getElementById('_form_' + id + '_'),
        err = document.createElement('div'),
        button = form.querySelector('button'),
        old_error = form.querySelector('._form_error')
      if (old_error) old_error.parentNode.removeChild(old_error)
      err.innerHTML = message
      err.className = '_error-inner _form_error _no_arrow'
      var wrapper = document.createElement('div')
      wrapper.className = '_form-inner'
      wrapper.appendChild(err)
      button.parentNode.insertBefore(wrapper, button)
      document.querySelector('[id^="_form"][id$="_submit"]').disabled = false
      if (html) {
        var div = document.createElement('div')
        div.className = '_error-html'
        div.innerHTML = html
        err.appendChild(div)
      }
    }

    window._load_script = function (url, callback) {
      var head = document.querySelector('head'),
        script = document.createElement('script'),
        r = false
      script.type = 'text/javascript'
      script.charSet = 'utf-8'
      script.src = url
      if (callback) {
        script.onload = script.onreadystatechange = function () {
          if (!r && (!this.readyState || this.readyState == 'complete')) {
            r = true
            callback()
          }
        }
      }
      head.appendChild(script)
    }

    function initForm() {
      if (window.location.search.search('excludeform') !== -1) return false

      var getCookie = function (name) {
        var match = document.cookie.match(
          new RegExp('(^|; )' + name + '=([^;]+)')
        )
        return match ? match[2] : null
      }

      var setCookie = function (name, value) {
        var now = new Date()
        var time = now.getTime()
        var expireTime = time + 1000 * 60 * 60 * 24 * 365
        now.setTime(expireTime)
        document.cookie = name + '=' + value + '; expires=' + now + ';path=/'
      }

      var addEvent = function (element, event, func) {
        if (element.addEventListener) {
          element.addEventListener(event, func)
        } else {
          var oldFunc = element['on' + event]
          element['on' + event] = function () {
            oldFunc.apply(this, arguments)
            func.apply(this, arguments)
          }
        }
      }

      var getUrlParam = function (name) {
        var params = new URLSearchParams(window.location.search)
        return params.get(name) || false
      }

      var remove_tooltips = function () {
        for (var i = 0; i < tooltips.length; i++) {
          tooltips[i].tip.parentNode.removeChild(tooltips[i].tip)
        }
        tooltips = []
      }

      var remove_tooltip = function (elem) {
        for (var i = 0; i < tooltips.length; i++) {
          if (tooltips[i].elem === elem) {
            tooltips[i].tip.parentNode.removeChild(tooltips[i].tip)
            tooltips.splice(i, 1)
            return
          }
        }
      }

      var create_tooltip = function (elem, text) {
        var tooltip = document.createElement('div'),
          arrow = document.createElement('div'),
          inner = document.createElement('div'),
          new_tooltip = {}
        if (elem.type != 'radio' && elem.type != 'checkbox') {
          tooltip.className = '_error'
          arrow.className = '_error-arrow'
          inner.className = '_error-inner'
          inner.innerHTML = text
          tooltip.appendChild(arrow)
          tooltip.appendChild(inner)
          elem.parentNode.appendChild(tooltip)
        } else {
          tooltip.className = '_error-inner _no_arrow'
          tooltip.innerHTML = text
          elem.parentNode.insertBefore(tooltip, elem)
          new_tooltip.no_arrow = true
        }
        new_tooltip.tip = tooltip
        new_tooltip.elem = elem
        tooltips.push(new_tooltip)
        return new_tooltip
      }

      var resize_tooltip = function (tooltip) {
        var rect = tooltip.elem.getBoundingClientRect()
        var doc = document.documentElement,
          scrollPosition =
            rect.top -
            ((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0))
        if (scrollPosition < 40) {
          tooltip.tip.className =
            tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '') +
            ' _below'
        } else {
          tooltip.tip.className =
            tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '') +
            ' _above'
        }
      }

      var resize_tooltips = function () {
        if (_removed) return
        for (var i = 0; i < tooltips.length; i++) {
          if (!tooltips[i].no_arrow) resize_tooltip(tooltips[i])
        }
      }

      var validate_field = function (elem, remove) {
        var tooltip = null,
          value = elem.value,
          no_error = true
        remove ? remove_tooltip(elem) : false
        if (elem.type != 'checkbox')
          elem.className = elem.className.replace(/ ?_has_error ?/g, '')
        if (elem.getAttribute('required') !== null) {
          if (
            elem.type == 'radio' ||
            (elem.type == 'checkbox' && /any/.test(elem.className))
          ) {
            var elems = form_to_submit.elements[elem.name]
            if (
              !(elems instanceof NodeList || elems instanceof HTMLCollection) ||
              elems.length <= 1
            ) {
              no_error = elem.checked
            } else {
              no_error = false
              for (var i = 0; i < elems.length; i++) {
                if (elems[i].checked) no_error = true
              }
            }
            if (!no_error) {
              tooltip = create_tooltip(elem, 'Por favor, selecione uma opção.')
            }
          } else if (elem.type == 'checkbox') {
            var elems = form_to_submit.elements[elem.name],
              found = false,
              err = []
            no_error = true
            for (var i = 0; i < elems.length; i++) {
              if (elems[i].getAttribute('required') === null) continue
              if (!found && elems[i] !== elem) return true
              found = true
              elems[i].className = elems[i].className.replace(
                / ?_has_error ?/g,
                ''
              )
              if (!elems[i].checked) {
                no_error = false
                elems[i].className = elems[i].className + ' _has_error'
                err.push('Marcar %s é necessário'.replace('%s', elems[i].value))
              }
            }
            if (!no_error) {
              tooltip = create_tooltip(elem, err.join('<br/>'))
            }
          } else if (elem.tagName == 'SELECT') {
            var selected = true
            if (elem.multiple) {
              selected = false
              for (var i = 0; i < elem.options.length; i++) {
                if (elem.options[i].selected) {
                  selected = true
                  break
                }
              }
            } else {
              for (var i = 0; i < elem.options.length; i++) {
                if (
                  elem.options[i].selected &&
                  (!elem.options[i].value || elem.options[i].value.match(/\n/g))
                ) {
                  selected = false
                }
              }
            }
            if (!selected) {
              elem.className = elem.className + ' _has_error'
              no_error = false
              tooltip = create_tooltip(elem, 'Por favor, selecione uma opção.')
            }
          } else if (value === undefined || value === null || value === '') {
            elem.className = elem.className + ' _has_error'
            no_error = false
            tooltip = create_tooltip(elem, 'Este campo é necessário.')
          }
        }
        if (no_error && elem.name == 'email') {
          if (
            !value.match(
              /^[\+_a-z0-9-'&=]+(\.[\+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i
            )
          ) {
            elem.className = elem.className + ' _has_error'
            no_error = false
            tooltip = create_tooltip(elem, 'Digite um e-mail válido')
          }
        }
        if (no_error && /date_field/.test(elem.className)) {
          if (!value.match(/^\d\d\d\d-\d\d-\d\d$/)) {
            elem.className = elem.className + ' _has_error'
            no_error = false
            tooltip = create_tooltip(elem, 'Digite uma data válida.')
          }
        }
        tooltip ? resize_tooltip(tooltip) : false
        return no_error
      }

      var needs_validate = function (el) {
        if (el.getAttribute('required') !== null) {
          return true
        }
        if (el.name === 'email' && el.value !== '') {
          return true
        }
        return false
      }

      var validate_form = function (e) {
        var err = form_to_submit.querySelector('._form_error'),
          no_error = true
        if (!submitted) {
          submitted = true
          for (var i = 0, len = allInputs.length; i < len; i++) {
            var input = allInputs[i]
            if (needs_validate(input)) {
              if (
                input.type == 'text' ||
                input.type == 'number' ||
                input.type == 'time'
              ) {
                addEvent(input, 'blur', function () {
                  this.value = this.value.trim()
                  validate_field(this, true)
                })
                addEvent(input, 'input', function () {
                  validate_field(this, true)
                })
              } else if (input.type == 'radio' || input.type == 'checkbox') {
                ;(function (el) {
                  var radios = form_to_submit.elements[el.name]
                  for (var i = 0; i < radios.length; i++) {
                    addEvent(radios[i], 'click', function () {
                      validate_field(el, true)
                    })
                  }
                })(input)
              } else if (input.tagName == 'SELECT') {
                addEvent(input, 'change', function () {
                  validate_field(this, true)
                })
              } else if (input.type == 'textarea') {
                addEvent(input, 'input', function () {
                  validate_field(this, true)
                })
              }
            }
          }
        }
        remove_tooltips()
        for (var i = 0, len = allInputs.length; i < len; i++) {
          var elem = allInputs[i]
          if (needs_validate(elem)) {
            if (elem.tagName.toLowerCase() !== 'select') {
              elem.value = elem.value.trim()
            }
            validate_field(elem) ? true : (no_error = false)
          }
        }
        if (!no_error && e) {
          e.preventDefault()
        }
        resize_tooltips()
        return no_error
      }

      var _form_serialize = function (form) {
        if (!form || form.nodeName !== 'FORM') {
          return
        }
        var i,
          j,
          q = []
        for (i = 0; i < form.elements.length; i++) {
          if (form.elements[i].name === '') {
            continue
          }
          switch (form.elements[i].nodeName) {
            case 'INPUT':
              switch (form.elements[i].type) {
                case 'text':
                case 'number':
                case 'date':
                case 'time':
                case 'hidden':
                case 'password':
                case 'button':
                case 'reset':
                case 'submit':
                  q.push(
                    form.elements[i].name +
                      '=' +
                      encodeURIComponent(form.elements[i].value)
                  )
                  break
                case 'checkbox':
                case 'radio':
                  if (form.elements[i].checked) {
                    q.push(
                      form.elements[i].name +
                        '=' +
                        encodeURIComponent(form.elements[i].value)
                    )
                  }
                  break
                case 'file':
                  break
              }
              break
            case 'TEXTAREA':
              q.push(
                form.elements[i].name +
                  '=' +
                  encodeURIComponent(form.elements[i].value)
              )
              break
            case 'SELECT':
              switch (form.elements[i].type) {
                case 'select-one':
                  q.push(
                    form.elements[i].name +
                      '=' +
                      encodeURIComponent(form.elements[i].value)
                  )
                  break
                case 'select-multiple':
                  for (j = 0; j < form.elements[i].options.length; j++) {
                    if (form.elements[i].options[j].selected) {
                      q.push(
                        form.elements[i].name +
                          '=' +
                          encodeURIComponent(form.elements[i].options[j].value)
                      )
                    }
                  }
                  break
              }
              break
            case 'BUTTON':
              switch (form.elements[i].type) {
                case 'reset':
                case 'submit':
                case 'button':
                  q.push(
                    form.elements[i].name +
                      '=' +
                      encodeURIComponent(form.elements[i].value)
                  )
                  break
              }
              break
          }
        }
        return q.join('&')
      }

      var form_submit = function (e) {
        e.preventDefault()
        if (validate_form()) {
          // use this trick to get the submit button & disable it using plain javascript
          document.querySelector(`#${formID}submit`).disabled = true
          var serialized = _form_serialize(
            document.getElementById(formID)
          ).replace(/%0A/g, '\\n')
          var err = form_to_submit.querySelector('._form_error')
          err ? err.parentNode.removeChild(err) : false
          _load_script(
            'https://medicalharbour86050.activehosted.com/proc.php?' +
              serialized +
              '&jsonp=true'
          )
        }
        return false
      }

      var _removed = false
      var form_to_submit = document.getElementById(formID)
      var allInputs = form_to_submit.querySelectorAll(
          'input, select, textarea'
        ),
        tooltips = [],
        submitted = false

      for (var i = 0; i < allInputs.length; i++) {
        var regexStr = 'field\\[(\\d+)\\]'
        var results = new RegExp(regexStr).exec(allInputs[i].name)
        if (results != undefined) {
          allInputs[i].dataset.name = window.cfields[results[1]]
        } else {
          allInputs[i].dataset.name = allInputs[i].name
        }
        var fieldVal = getUrlParam(allInputs[i].dataset.name)

        if (fieldVal) {
          if (allInputs[i].dataset.autofill === 'false') {
            continue
          }
          if (allInputs[i].type == 'radio' || allInputs[i].type == 'checkbox') {
            if (allInputs[i].value == fieldVal) {
              allInputs[i].checked = true
            }
          } else {
            allInputs[i].value = fieldVal
          }
        }
      }

      addEvent(window, 'resize', resize_tooltips)
      addEvent(window, 'scroll', resize_tooltips)
      addEvent(form_to_submit, 'submit', form_submit)
    }
    initForm()
  }, [formID])

  useEffect(() => {
    setWhatsAppLink(`https://wa.me/${labelsContactWhats.replace(/\D/g, '')}`)
  }, [labelsContactWhats])

  const renderActiveCampaignFormPT = () => {
    return (
      <div className="form-container">
        <form
          method="POST"
          action="https://medicalharbour86050.activehosted.com/proc.php"
          id="_form_31_"
          className="_form _form_31 _inline-form _inline-style _dark"
          noValidate
        >
          <input type="hidden" name="u" value="31" />
          <input type="hidden" name="f" value="31" />
          <input type="hidden" name="s" />
          <input type="hidden" name="c" value="0" />
          <input type="hidden" name="m" value="0" />
          <input type="hidden" name="act" value="sub" />
          <input type="hidden" name="v" value="2" />
          <input
            type="hidden"
            name="or"
            value="5729260e68c293ec09aca2772591aa1d"
          />
          <div className="_form-content">
            <div className="_form_element _field-department _inline-style ">
              <label htmlFor="field[112]" className="_form-label">
                {`${labelsDepartment}*`}
              </label>
              <div className="_field-wrapper">
                <select
                  name="field[112]"
                  id="field[112]"
                  defaultValue={'default'}
                  required
                >
                  <option value="default">{placeholdersDepartment}</option>
                  <option value="Comercial">Comercial</option>
                  <option value="Suporte">Suporte</option>
                  <option value="Outros">Outros</option>
                </select>
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-name _inline-style ">
              <label htmlFor="fullname" className="_form-label">
                {`${labelsFullName}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="fullname"
                  name="fullname"
                  placeholder={placeholdersName}
                  required
                />
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-institution _inline-style ">
              <label htmlFor="customer_account" className="_form-label">
                {`${labelsInstitution}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="customer_account"
                  name="customer_account"
                  placeholder={placeholdersInstitution}
                  required
                />
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-is-afya _inline-style">
              <fieldset className="_form-fieldset">
                <legend className="_form-label">{`${labelsIsAfya}*`}</legend>
                <div className="flexbox">
                  <div className="_row _checkbox-radio">
                    <input
                      id="field_113Sim"
                      type="radio"
                      name="field[113]"
                      value="Sim"
                      required
                    />
                    <span>
                      <label htmlFor="field_113Sim">Sim</label>
                    </span>
                  </div>
                  <div className="_row _checkbox-radio">
                    <input
                      id="field_113Não"
                      type="radio"
                      name="field[113]"
                      value="Não"
                    />
                    <span>
                      <label htmlFor="field_113Não">Não</label>
                    </span>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="_form_element _field-email _inline-style ">
              <label htmlFor="email" className="_form-label">
                {`${labelsEmail}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="email"
                  name="email"
                  placeholder={placeholdersEmail}
                  required
                />
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-phone _inline-style">
              <label htmlFor="field[108]" className="_form-label">
                {`${labelsMobile}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="field[108]"
                  name="field[108]"
                  placeholder={placeholdersPhone}
                  required
                />
              </div>
            </div>
            <div className="_form_element _field-country _inline-style ">
              <label htmlFor="field[109]" className="_form-label">
                {`${labelsCountry}*`}
              </label>
              <div className="_field-wrapper">
                <select
                  name="field[109]"
                  id="field[109]"
                  defaultValue={'default'}
                  required
                >
                  <option value="default">{placeholdersCountry}</option>
                  <option value="Abecásia">Abecásia</option>
                  <option value="Açores">Açores</option>
                  <option value="Acrotiri e Deceleia">
                    Acrotiri e Deceleia
                  </option>
                  <option value="Afeganistão">Afeganistão</option>
                  <option value="África do Sul">África do Sul</option>
                  <option value="Albânia">Albânia</option>
                  <option value="Alemanha">Alemanha</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Anguila">Anguila</option>
                  <option value="Antígua e Barbuda">Antígua e Barbuda</option>
                  <option value="Arábia Saudita">Arábia Saudita</option>
                  <option value="Argélia">Argélia</option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armênia">Armênia</option>
                  <option value="Aruba">Aruba</option>
                  <option value="Austrália">Austrália</option>
                  <option value="Áustria">Áustria</option>
                  <option value="Azerbaijão">Azerbaijão</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Barém">Barém</option>
                  <option value="Bélgica">Bélgica</option>
                  <option value="Belize">Belize</option>
                  <option value="Benim">Benim</option>
                  <option value="Bermudas">Bermudas</option>
                  <option value="Bielorrússia">Bielorrússia</option>
                  <option value="Bolívia">Bolívia</option>
                  <option value="Bonaire">Bonaire</option>
                  <option value="Bósnia e Herzegovina">
                    Bósnia e Herzegovina
                  </option>
                  <option value="Botsuana">Botsuana</option>
                  <option value="Brasil">Brasil</option>
                  <option value="Brunei">Brunei</option>
                  <option value="Bulgária">Bulgária</option>
                  <option value="Burquina Faso">Burquina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Butão">Butão</option>
                  <option value="Cabo Verde">Cabo Verde</option>
                  <option value="Camarões">Camarões</option>
                  <option value="Camboja">Camboja</option>
                  <option value="Canadá">Canadá</option>
                  <option value="Canárias">Canárias</option>
                  <option value="Catar">Catar</option>
                  <option value="Cazaquistão">Cazaquistão</option>
                  <option value="Chade">Chade</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Chipre">Chipre</option>
                  <option value="Chipre do Norte">Chipre do Norte</option>
                  <option value="Colômbia">Colômbia</option>
                  <option value="Comores">Comores</option>
                  <option value="Coréia do Norte">Coréia do Norte</option>
                  <option value="Coréia do Sul">Coréia do Sul</option>
                  <option value="Costa do Marfim">Costa do Marfim</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Croácia">Croácia</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Curaçao">Curaçao</option>
                  <option value="Dinamarca">Dinamarca</option>
                  <option value="Djibuti">Djibuti</option>
                  <option value="Domínica">Domínica</option>
                  <option value="Egito">Egito</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Emirados Árabes Unidos">
                    Emirados Árabes Unidos
                  </option>
                  <option value="Equador">Equador</option>
                  <option value="Eritreia">Eritreia</option>
                  <option value="Escócia">Escócia</option>
                  <option value="Eslováquia">Eslováquia</option>
                  <option value="Eslovênia">Eslovênia</option>
                  <option value="Espanha">Espanha</option>
                  <option value="Estados Unidos da América">
                    Estados Unidos da América
                  </option>
                  <option value="Estônia">Estônia</option>
                  <option value="Etiópia">Etiópia</option>
                  <option value="Faroé">Faroé</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Filipinas">Filipinas</option>
                  <option value="Finlândia">Finlândia</option>
                  <option value="França">França</option>
                  <option value="Gabão">Gabão</option>
                  <option value="Gâmbia">Gâmbia</option>
                  <option value="Gana">Gana</option>
                  <option value="Geórgia">Geórgia</option>
                  <option value="Geórgia do Sul e Sandwich do Sul">
                    Geórgia do Sul e Sandwich do Sul
                  </option>
                  <option value="Gibraltar">Gibraltar</option>
                  <option value="Granada">Granada</option>
                  <option value="Grécia">Grécia</option>
                  <option value="Groenlândia">Groenlândia</option>
                  <option value="Guadalupe">Guadalupe</option>
                  <option value="Guam">Guam</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guernsey">Guernsey</option>
                  <option value="Guiana">Guiana</option>
                  <option value="Guiana Francesa">Guiana Francesa</option>
                  <option value="Guiné">Guiné</option>
                  <option value="Guiné Bissau">Guiné Bissau</option>
                  <option value="Guiné Equatorial">Guiné Equatorial</option>
                  <option value="Haiti">Haiti</option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hong Kong">Hong Kong</option>
                  <option value="Hungria">Hungria</option>
                  <option value="Iêmen">Iêmen</option>
                  <option value="Ilha Bouvet">Ilha Bouvet</option>
                  <option value="Ilha da Madeira">Ilha da Madeira</option>
                  <option value="Ilha de Clipperton">Ilha de Clipperton</option>
                  <option value="Ilha de Man">Ilha de Man</option>
                  <option value="Ilha de Navassa">Ilha de Navassa</option>
                  <option value="Ilha do Natal">Ilha do Natal</option>
                  <option value="Ilha Jan Mayen">Ilha Jan Mayen</option>
                  <option value="Ilha Norfolk">Ilha Norfolk</option>
                  <option value="Ilha Wake">Ilha Wake</option>
                  <option value="Ilhas Ashmore e Cartier">
                    Ilhas Ashmore e Cartier
                  </option>
                  <option value="Ilhas Caimão">Ilhas Caimão</option>
                  <option value="Ilhas Cocos">Ilhas Cocos</option>
                  <option value="Ilhas Cook">Ilhas Cook</option>
                  <option value="Ilhas do Mar de Coral">
                    Ilhas do Mar de Coral
                  </option>
                  <option value="Ilhas Falkland">Ilhas Falkland</option>
                  <option value="Ilhas Heard e Mcdonald">
                    Ilhas Heard e Mcdonald
                  </option>
                  <option value="Ilhas Marshall">Ilhas Marshall</option>
                  <option value="Ilhas Paracel">Ilhas Paracel</option>
                  <option value="Ilhas Pitcairn">Ilhas Pitcairn</option>
                  <option value="Ilhas Salomão">Ilhas Salomão</option>
                  <option value="Ilhas Spratly">Ilhas Spratly</option>
                  <option value="Ilhas Turcas e Caicos">
                    Ilhas Turcas e Caicos
                  </option>
                  <option value="Ilhas Virgens Americanas">
                    Ilhas Virgens Americanas
                  </option>
                  <option value="Ilhas Virgens Britânicas">
                    Ilhas Virgens Britânicas
                  </option>
                  <option value="Índia">Índia</option>
                  <option value="Indonésia">Indonésia</option>
                  <option value="Inglaterra">Inglaterra</option>
                  <option value="Irã">Irã</option>
                  <option value="Iraque">Iraque</option>
                  <option value="Irlanda">Irlanda</option>
                  <option value="Irlanda do Norte">Irlanda do Norte</option>
                  <option value="Islândia">Islândia</option>
                  <option value="Israel">Israel</option>
                  <option value="Itália">Itália</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japão">Japão</option>
                  <option value="Jersey">Jersey</option>
                  <option value="Jordânia">Jordânia</option>
                  <option value="Kosovo">Kosovo</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Laos">Laos</option>
                  <option value="Lesoto">Lesoto</option>
                  <option value="Letônia">Letônia</option>
                  <option value="Líbano">Líbano</option>
                  <option value="Libéria">Libéria</option>
                  <option value="Líbia">Líbia</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lituânia">Lituânia</option>
                  <option value="Luxemburgo">Luxemburgo</option>
                  <option value="Macau">Macau</option>
                  <option value="Macedônia do Norte">Macedônia do Norte</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malásia">Malásia</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Maldivas">Maldivas</option>
                  <option value="Mali">Mali</option>
                  <option value="Malta">Malta</option>
                  <option value="Marianas do Norte">Marianas do Norte</option>
                  <option value="Marrocos">Marrocos</option>
                  <option value="Martinica">Martinica</option>
                  <option value="Maurício">Maurício</option>
                  <option value="Mauritânia">Mauritânia</option>
                  <option value="Mayotte">Mayotte</option>
                  <option value="México">México</option>
                  <option value="Micronésia">Micronésia</option>
                  <option value="Moçambique">Moçambique</option>
                  <option value="Moldávia">Moldávia</option>
                  <option value="Mônaco">Mônaco</option>
                  <option value="Mongólia">Mongólia</option>
                  <option value="Monserrate">Monserrate</option>
                  <option value="Montenegro">Montenegro</option>
                  <option value="Myanmar">Myanmar</option>
                  <option value="Nagorno-Karabakh">Nagorno-Karabakh</option>
                  <option value="Namíbia">Namíbia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Nicarágua">Nicarágua</option>
                  <option value="Níger">Níger</option>
                  <option value="Nigéria">Nigéria</option>
                  <option value="Niue">Niue</option>
                  <option value="Noruega">Noruega</option>
                  <option value="Nova Caledônia">Nova Caledônia</option>
                  <option value="Nova Zelândia">Nova Zelândia</option>
                  <option value="Omã">Omã</option>
                  <option value="Ossétia Do Sul">Ossétia Do Sul</option>
                  <option value="País de Gales">País de Gales</option>
                  <option value="Países Baixos">Países Baixos</option>
                  <option value="Palau">Palau</option>
                  <option value="Palestina">Palestina</option>
                  <option value="Panamá">Panamá</option>
                  <option value="Papua-Nova Guiné">Papua-Nova Guiné</option>
                  <option value="Paquistão">Paquistão</option>
                  <option value="Paraguai">Paraguai</option>
                  <option value="Peru">Peru</option>
                  <option value="Polinésia Francesa">Polinésia Francesa</option>
                  <option value="Polônia">Polônia</option>
                  <option value="Porto Rico">Porto Rico</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Quênia">Quênia</option>
                  <option value="Quirguizistão">Quirguizistão</option>
                  <option value="Quiribati">Quiribati</option>
                  <option value="Reino Unido">Reino Unido</option>
                  <option value="República Centro-Africana">
                    República Centro-Africana
                  </option>
                  <option value="República Democrática do Congo">
                    República Democrática do Congo
                  </option>
                  <option value="República Do Congo">República Do Congo</option>
                  <option value="República Dominicana">
                    República Dominicana
                  </option>
                  <option value="República Tcheca">República Tcheca</option>
                  <option value="Reunião">Reunião</option>
                  <option value="Romênia">Romênia</option>
                  <option value="Ruanda">Ruanda</option>
                  <option value="Rússia">Rússia</option>
                  <option value="Saara Ocidental">Saara Ocidental</option>
                  <option value="Saba">Saba</option>
                  <option value="Samoa">Samoa</option>
                  <option value="Samoa Americana">Samoa Americana</option>
                  <option value="San Marino">San Marino</option>
                  <option value="Santa Helena">Santa Helena</option>
                  <option value="Santa Lúcia">Santa Lúcia</option>
                  <option value="Santo Eustáquio">Santo Eustáquio</option>
                  <option value="São Bartolomeu">São Bartolomeu</option>
                  <option value="São Cristóvão e Neves">
                    São Cristóvão e Neves
                  </option>
                  <option value="São Martinho Francesa">
                    São Martinho Francesa
                  </option>
                  <option value="São Martinho Holandesa">
                    São Martinho Holandesa
                  </option>
                  <option value="São Pedro e Miquelon">
                    São Pedro e Miquelon
                  </option>
                  <option value="São Tomé e Príncipe">
                    São Tomé e Príncipe
                  </option>
                  <option value="São Vicente e Granadinas">
                    São Vicente e Granadinas
                  </option>
                  <option value="Seicheles">Seicheles</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Serra Leoa">Serra Leoa</option>
                  <option value="Sérvia">Sérvia</option>
                  <option value="Singapura">Singapura</option>
                  <option value="Síria">Síria</option>
                  <option value="Somália">Somália</option>
                  <option value="Somalilândia">Somalilândia</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="Suazilândia">Suazilândia</option>
                  <option value="Sudão">Sudão</option>
                  <option value="Sudão Do Sul">Sudão Do Sul</option>
                  <option value="Suécia">Suécia</option>
                  <option value="Suíça">Suíça</option>
                  <option value="Suriname">Suriname</option>
                  <option value="Tailândia">Tailândia</option>
                  <option value="Taiwan">Taiwan</option>
                  <option value="Tajiquistão">Tajiquistão</option>
                  <option value="Tanzânia">Tanzânia</option>
                  <option value="Território Britânico do Oceano Índico">
                    Território Britânico do Oceano Índico
                  </option>
                  <option value="Territórios Austrais Franceses">
                    Territórios Austrais Franceses
                  </option>
                  <option value="Timor Leste">Timor Leste</option>
                  <option value="Togo">Togo</option>
                  <option value="Tokelau">Tokelau</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Transnístria">Transnístria</option>
                  <option value="Trindade e Tobago">Trindade e Tobago</option>
                  <option value="Tunísia">Tunísia</option>
                  <option value="Turquemenistão">Turquemenistão</option>
                  <option value="Turquia">Turquia</option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Ucrânia">Ucrânia</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Uruguai">Uruguai</option>
                  <option value="Uzbequistão">Uzbequistão</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Vaticano">Vaticano</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Vietnã">Vietnã</option>
                  <option value="Wallis e Futuna">Wallis e Futuna</option>
                  <option value="Zâmbia">Zâmbia</option>
                  <option value="Zanzibar">Zanzibar</option>
                  <option value="Zimbábue">Zimbábue</option>
                </select>
              </div>
            </div>
            <div className="_form_element _field-profession _inline-style ">
              <label htmlFor="field[56]" className="_form-label">
                {`${labelsProfession}*`}
              </label>
              <div className="_field-wrapper">
                <select
                  name="field[56]"
                  id="field[56]"
                  defaultValue={'default'}
                  required
                >
                  <option value="default">{placeholdersProfession}</option>
                  <option value="Advogado Forense">Advogado Forense</option>
                  <option value="Coordenador de Curso">
                    Coordenador de Curso
                  </option>
                  <option value="Dentista">Dentista</option>
                  <option value="Estudante - Medicina">
                    Estudante - Medicina
                  </option>
                  <option value="Estudante - Veterinária">
                    Estudante - Veterinária
                  </option>
                  <option value="Estudante - Outro Curso da Área da Saúde">
                    Estudante - Outro Curso da Área da Saúde
                  </option>
                  <option value="Médico - Cardiologista">
                    Médico - Cardiologista
                  </option>
                  <option value="Médico - Cirurgião">Médico - Cirurgião</option>
                  <option value="Médico - Clínico Geral">
                    Médico - Clínico Geral
                  </option>
                  <option value="Médico - Neurologista">
                    Médico - Neurologista
                  </option>
                  <option value="Médico - Ortopedista">
                    Médico - Ortopedista
                  </option>
                  <option value="Médico - Radiologista">
                    Médico - Radiologista
                  </option>
                  <option value="Médico - Residente">Médico - Residente</option>
                  <option value="Médico - Outra Especialidade Médica">
                    Médico - Outra Especialidade Médica
                  </option>
                  <option value="Pesquisador">Pesquisador</option>
                  <option value="Professor">Professor</option>
                  <option value="Profissional de TI">Profissional de TI</option>
                  <option value="Reitor">Reitor</option>
                  <option value="Técnico em Radiologia">
                    Técnico em Radiologia
                  </option>
                  <option value="Veterinário">Veterinário</option>
                  <option value="Quiroprata">Quiroprata</option>
                  <option value="Outro">Outro</option>
                  <option value="Orientadora EAD">Orientadora EAD</option>
                  <option value="Editora">Editora</option>
                  <option value="Tutora">Tutora</option>
                  <option value="Tutoria">Tutoria</option>
                  <option value="Diretor">Diretor</option>
                  <option value="Coord.">Coord.</option>
                  <option value="Criação de conteúdo">
                    Criação de conteúdo
                  </option>
                  <option value="Coord. EAD">Coord. EAD</option>
                  <option value="Capitão">Capitão</option>
                  <option value="Supervisor">Supervisor</option>
                  <option value="Tutora EAD">Tutora EAD</option>
                  <option value="Coordenadora">Coordenadora</option>
                  <option value="gestora">gestora</option>
                  <option value="Professora">Professora</option>
                  <option value="Gestor EAD">Gestor EAD</option>
                  <option value="Prof de Anatomia">Prof de Anatomia</option>
                  <option value="Pedagógico">Pedagógico</option>
                  <option value="Diretora acadêmica">Diretora acadêmica</option>
                  <option value="Chefe de departamento">
                    Chefe de departamento
                  </option>
                  <option value="Tec. Ass. Educacionais">
                    Tec. Ass. Educacionais
                  </option>
                  <option value="Coord. Saúde">Coord. Saúde</option>
                  <option value="CFO">CFO</option>
                  <option value="Gerente">Gerente</option>
                  <option value="Prof. Doutor">Prof. Doutor</option>
                  <option value="Pró-reitora administrativa">
                    Pró-reitora administrativa
                  </option>
                  <option value="Coord. Geral EAD">Coord. Geral EAD</option>
                  <option value="Pró-reitor acadêmico">
                    Pró-reitor acadêmico
                  </option>
                  <option value="Pro Reitor ">Pro Reitor</option>
                  <option value="Coord. UAB/EAD">Coord. UAB/EAD</option>
                  <option value="Diretora">Diretora</option>
                  <option value="Tec. Em Tecnologia da Informação">
                    Tec. Em Tecnologia da Informação
                  </option>
                  <option value="62981823656">62981823656</option>
                  <option value="MARKETING">MARKETING</option>
                  <option value="ORIENTADOR DE ESTUDOS">
                    ORIENTADOR DE ESTUDOS
                  </option>
                  <option value="RESOLVEDORA DE PROBLEMAS">
                    RESOLVEDORA DE PROBLEMAS
                  </option>
                  <option value="INTERNATIONAL SALES">
                    INTERNATIONAL SALES
                  </option>
                  <option value="PROFESSORA">PROFESSORA</option>
                  <option value="VENDAS">VENDAS</option>
                  <option value="DIRETOR">DIRETOR</option>
                  <option value="PROFESSOR">PROFESSOR</option>
                  <option value="DIRECTOR LATIN AMERICA">
                    DIRECTOR LATIN AMERICA
                  </option>
                  <option value="DIRETORA">DIRETORA</option>
                  <option value="MANTENEDOR">MANTENEDOR</option>
                  <option value="COORDENADORA PEDAGÓGICA">
                    COORDENADORA PEDAGÓGICA
                  </option>
                  <option value="COORDENADORA">COORDENADORA</option>
                  <option value="VICE- DIRETORA">VICE- DIRETORA</option>
                  <option value="COORDENADOR">COORDENADOR</option>
                  <option value="GERENTE">GERENTE</option>
                  <option value="ANALISTA DE TECNOLOGIAS EDUCACIONAIS">
                    ANALISTA DE TECNOLOGIAS EDUCACIONAIS
                  </option>
                  <option value="ASSISTENTE">ASSISTENTE</option>
                  <option value="GERENTE DE PROJETOS EDUCACIONAIS">
                    GERENTE DE PROJETOS EDUCACIONAIS
                  </option>
                  <option value="ASSISTENTE DE EDUCAÇÃO A DISTÂNCIA">
                    ASSISTENTE DE EDUCAÇÃO A DISTÂNCIA
                  </option>
                  <option value="INTERNATIONAL DISTRIBUTOR MANAGER">
                    INTERNATIONAL DISTRIBUTOR MANAGER
                  </option>
                  <option value="EXECUTIVA DE CONTAS">
                    EXECUTIVA DE CONTAS
                  </option>
                  <option value="DIRETOR FINANCEIRO">DIRETOR FINANCEIRO</option>
                  <option value="GESTÃO">GESTÃO</option>
                  <option value="DIRETOR FINAN">DIRETOR FINAN</option>
                  <option value="MANTENEDORA">MANTENEDORA</option>
                  <option value="FINANCEIRO">FINANCEIRO</option>
                  <option value="ANALISTA DE TI">ANALISTA DE TI</option>
                  <option value="DIRETOR DE EDUCAÇÃO">
                    DIRETOR DE EDUCAÇÃO
                  </option>
                  <option value="CEO">CEO</option>
                  <option value="GERENTE PEDAGÓGICO">GERENTE PEDAGÓGICO</option>
                  <option value="SUPERINTENDENTE DE EDUCAÇÃO">
                    SUPERINTENDENTE DE EDUCAÇÃO
                  </option>
                  <option value="REPRESENTANTE COMERCIAL">
                    REPRESENTANTE COMERCIAL
                  </option>
                  <option value="SOCIO">SOCIO</option>
                  <option value="GERENTE DE SUCESSO DO CLIENTE">
                    GERENTE DE SUCESSO DO CLIENTE
                  </option>
                  <option value="DIRETORA COMERCIAL">DIRETORA COMERCIAL</option>
                  <option value="COORDENADOR JURÍDICO">
                    COORDENADOR JURÍDICO
                  </option>
                  <option value="COORDENADOR DE INOVAÇÃO">
                    COORDENADOR DE INOVAÇÃO
                  </option>
                  <option value="COORDENADOR PEDAGÓGICO">
                    COORDENADOR PEDAGÓGICO
                  </option>
                  <option value="DESIGN EDUCACIONAL">DESIGN EDUCACIONAL</option>
                  <option value="SUPERVISOR DE EDUCAÇÃO BÁSICA">
                    SUPERVISOR DE EDUCAÇÃO BÁSICA
                  </option>
                  <option value="COORDENADORA PEDAGOGICA">
                    COORDENADORA PEDAGOGICA
                  </option>
                  <option value="SÓCIO-DIRETOR">SÓCIO-DIRETOR</option>
                  <option value="MATENEDOR">MATENEDOR</option>
                  <option value="GESTÃO EDUCACIONAL">GESTÃO EDUCACIONAL</option>
                  <option value="DIRETOR PEDAGÓGICO">DIRETOR PEDAGÓGICO</option>
                  <option value="DIRETOR ADM FINANCEIRO">
                    DIRETOR ADM FINANCEIRO
                  </option>
                  <option value="GERENTE FINANCEIRO">GERENTE FINANCEIRO</option>
                  <option value="ARQUITETO DE SOLUÇÕES">
                    ARQUITETO DE SOLUÇÕES
                  </option>
                  <option value="REPRESENTANTE DE VENDAS">
                    REPRESENTANTE DE VENDAS
                  </option>
                  <option value="ORIENTADORA EDUCACIONAL">
                    ORIENTADORA EDUCACIONAL
                  </option>
                  <option value="PEDAGOGA">PEDAGOGA</option>
                  <option value="ASSITENTE DE COORDENAÇÃO">
                    ASSITENTE DE COORDENAÇÃO
                  </option>
                  <option value="COORDENAÇÃO">COORDENAÇÃO</option>
                  <option value="ANALISTA DE MARKETING">
                    ANALISTA DE MARKETING
                  </option>
                  <option value="DESIGN GRÁFICO">DESIGN GRÁFICO</option>
                  <option value="DESIGNER">DESIGNER</option>
                  <option value="COORDENADOR DE VENDAS">
                    COORDENADOR DE VENDAS
                  </option>
                  <option value="ADMINISTRATIVO">ADMINISTRATIVO</option>
                  <option value="PROFESSORA DE EDUCAÇÃO FÍSICA">
                    PROFESSORA DE EDUCAÇÃO FÍSICA
                  </option>
                  <option value="COMERCIAL">COMERCIAL</option>
                  <option value="DIRETOR EXECUTIVO">DIRETOR EXECUTIVO</option>
                  <option value="COORDENADOR ADMINISTRATIVO E FINANCEIRO">
                    COORDENADOR ADMINISTRATIVO E FINANCEIRO
                  </option>
                  <option value="DIRIGENTE ADMINISTRATIVO DA EDUCAÇÃO INFANTIL">
                    DIRIGENTE ADMINISTRATIVO DA EDUCAÇÃO INFANTIL
                  </option>
                  <option value="NOVAS PARCERIAS">NOVAS PARCERIAS</option>
                  <option value="DIRETORA FINANCEIRA">
                    DIRETORA FINANCEIRA
                  </option>
                  <option value="PSICÓLOGO">PSICÓLOGO</option>
                  <option value="FOUNDER">FOUNDER</option>
                  <option value="GERENTE DE PLANEJAMENTO ACADEMICO">
                    GERENTE DE PLANEJAMENTO ACADEMICO
                  </option>
                  <option value="CHEFE SUBDIVISÃO PLANEJAMENTO">
                    CHEFE SUBDIVISÃO PLANEJAMENTO
                  </option>
                  <option value="GESTORA">GESTORA</option>
                  <option value="COORDENADOR/PROFESSOR">
                    COORDENADOR/PROFESSOR
                  </option>
                  <option value="SOCIA">SOCIA</option>
                  <option value="HEAD EDUCACIONAL">HEAD EDUCACIONAL</option>
                  <option value="DIRETOR DE CONTEÚDO DIGITAL">
                    DIRETOR DE CONTEÚDO DIGITAL
                  </option>
                  <option value="DIRETORA PROPRIETARIA">
                    DIRETORA PROPRIETARIA
                  </option>
                  <option value="DIRETOR DE ESCOLA">DIRETOR DE ESCOLA</option>
                  <option value="TÉCNICO">TÉCNICO</option>
                  <option value="GERENTE DE PROJETOS">
                    GERENTE DE PROJETOS
                  </option>
                  <option value="COORDENADOR DE CONTEÚDO 3D">
                    COORDENADOR DE CONTEÚDO 3D
                  </option>
                  <option value="GESTORA DE RELACIONAMENTO">
                    GESTORA DE RELACIONAMENTO
                  </option>
                  <option value="DIRETORA ACADÊMICA">DIRETORA ACADÊMICA</option>
                  <option value="SÓCIO">SÓCIO</option>
                  <option value="GERENTE DE PRODUTO">GERENTE DE PRODUTO</option>
                  <option value="COORDENADORA DE NEGÓCIOS">
                    COORDENADORA DE NEGÓCIOS
                  </option>
                  <option value="DIRETOR EDUCAÇÃO PROSSIONAL">
                    DIRETOR EDUCAÇÃO PROSSIONAL
                  </option>
                  <option value="COORDENADOR DE TECNOLOGIAS EDUCACIONAIS">
                    COORDENADOR DE TECNOLOGIAS EDUCACIONAIS
                  </option>
                  <option value="CONSULTORA EDUCACIONAL">
                    CONSULTORA EDUCACIONAL
                  </option>
                  <option value="CONSULTOR EDUCACIONAL">
                    CONSULTOR EDUCACIONAL
                  </option>
                  <option value="CONSULTORA">CONSULTORA</option>
                  <option value="ANALISTA DE TECNOLOGIA EDUCACIONAL SENIOR">
                    ANALISTA DE TECNOLOGIA EDUCACIONAL SENIOR
                  </option>
                  <option value="ASSISTENTE DE TECNOLOGIA EDUCACIONAL">
                    ASSISTENTE DE TECNOLOGIA EDUCACIONAL
                  </option>
                  <option value="HEAD DE MARKETING">HEAD DE MARKETING</option>
                  <option value="GERENTE COMERCIAL">GERENTE COMERCIAL</option>
                  <option value="REPRESENTANTE">REPRESENTANTE</option>
                  <option value="VICE-DIREÇÁO">VICE-DIREÇÁO</option>
                  <option value="ORIENTAÇÃO ESCOLAR">ORIENTAÇÃO ESCOLAR</option>
                  <option value="GERENTE DE EDUCAÇÃO INFANTIL">
                    GERENTE DE EDUCAÇÃO INFANTIL
                  </option>
                  <option value="DIRETORA DE PROJETOS">
                    DIRETORA DE PROJETOS
                  </option>
                  <option value="DIRETOR DE EXPANSAO">
                    DIRETOR DE EXPANSAO
                  </option>
                  <option value="AUXILIAR DE RELAÇÕES PÚBLICAS">
                    AUXILIAR DE RELAÇÕES PÚBLICAS
                  </option>
                  <option value="SUP. PROJETOS">SUP. PROJETOS</option>
                  <option value="SUPERVISORA DE COMUNICAÇÃO">
                    SUPERVISORA DE COMUNICAÇÃO
                  </option>
                  <option value="CONSULTOR">CONSULTOR</option>
                  <option value="SUPERINTENDENTE">SUPERINTENDENTE</option>
                  <option value="ORIENTADOR EDUCACIONAL">
                    ORIENTADOR EDUCACIONAL
                  </option>
                  <option value="BUSINESS DEVELOPMENT">
                    BUSINESS DEVELOPMENT
                  </option>
                  <option value="COORDENADOR DE TI">COORDENADOR DE TI</option>
                  <option value="ESTUDANTE">ESTUDANTE</option>
                  <option value="DIREÇÃO DE COMUNICAÇÃO E MARKETING">
                    DIREÇÃO DE COMUNICAÇÃO E MARKETING
                  </option>
                  <option value="DIRETORA PEDAGÓGICA">
                    DIRETORA PEDAGÓGICA
                  </option>
                  <option value="DIREÇÃO">DIREÇÃO</option>
                  <option value="HEAD">HEAD</option>
                  <option value="GROWTH">GROWTH</option>
                  <option value="COORDENADORA DE TREINAMENTO">
                    COORDENADORA DE TREINAMENTO
                  </option>
                  <option value="GERENTE DE FUTURISMO">
                    GERENTE DE FUTURISMO
                  </option>
                  <option value="COORDENADORA GERAL ADMINISTRATIVA">
                    COORDENADORA GERAL ADMINISTRATIVA
                  </option>
                  <option value="COORDENADORA ADM">COORDENADORA ADM</option>
                  <option value="ENCARREGADO DE SERVIÇOS GERAIS">
                    ENCARREGADO DE SERVIÇOS GERAIS
                  </option>
                  <option value="ANALISTA">ANALISTA</option>
                  <option value="DESENVOLVIMENTO DE NOVOS NEGÓCIOS">
                    DESENVOLVIMENTO DE NOVOS NEGÓCIOS
                  </option>
                  <option value="SUPERVISOR DE TI">SUPERVISOR DE TI</option>
                  <option value="ANALISTA DE SISTEMAS SR.">
                    ANALISTA DE SISTEMAS SR.
                  </option>
                  <option value="ESPECIALISTA ENSINO DIGITAL">
                    ESPECIALISTA ENSINO DIGITAL
                  </option>
                  <option value="DIRETORA DE PESQUISA E PÓS GRADUAÇÃO">
                    DIRETORA DE PESQUISA E PÓS GRADUAÇÃO
                  </option>
                  <option value="FOTOGRAFO">FOTOGRAFO</option>
                  <option value="SECRETÁRIA DE EDUCAÇÃO">
                    SECRETÁRIA DE EDUCAÇÃO
                  </option>
                  <option value="COORDENADORA DE TECNOLOGIA EDUCACIONAL">
                    COORDENADORA DE TECNOLOGIA EDUCACIONAL
                  </option>
                  <option value="PRESIDENTE ESTADUAL">
                    PRESIDENTE ESTADUAL
                  </option>
                  <option value="GESTOR">GESTOR</option>
                  <option value="BUSINESS DEVELOPMENT - PARCERIAS">
                    BUSINESS DEVELOPMENT - PARCERIAS
                  </option>
                  <option value="PRODUTOR AUDIOVISUAL SR">
                    PRODUTOR AUDIOVISUAL SR
                  </option>
                  <option value="PRODUTOR AUDIOVISUAL">
                    PRODUTOR AUDIOVISUAL
                  </option>
                  <option value="GERENTE SE">GERENTE SE</option>
                  <option value="DIRETOR ADM">DIRETOR ADM</option>
                  <option value="COORDENADOR EDUCACIONAL">
                    COORDENADOR EDUCACIONAL
                  </option>
                  <option value="DIRETOR ADMINISTRATIVO">
                    DIRETOR ADMINISTRATIVO
                  </option>
                  <option value="GERENTE DE MARKETING E RELACIONAMENTO">
                    GERENTE DE MARKETING E RELACIONAMENTO
                  </option>
                  <option value="PROJETO MAKER">PROJETO MAKER</option>
                  <option value="ASSOCIATE DIRECTOR">ASSOCIATE DIRECTOR</option>
                  <option value="AUXILIAR ADM">AUXILIAR ADM</option>
                  <option value="DOCTORAL STUDENT">DOCTORAL STUDENT</option>
                  <option value="MANTENEDA">MANTENEDA</option>
                  <option value="COORDENADORA GERAL - ENSINO BILÍNGUE">
                    COORDENADORA GERAL - ENSINO BILÍNGUE
                  </option>
                  <option value="ASSIST ADMINISTRATIVO">
                    ASSIST ADMINISTRATIVO
                  </option>
                  <option value="COORD(A) - CIÊNCIA">COORD(A) - CIÊNCIA</option>
                  <option value="APPLE PROFESSIONAL LEARNING">
                    APPLE PROFESSIONAL LEARNING
                  </option>
                  <option value="DIRETORA GERAL">DIRETORA GERAL</option>
                  <option value="CHIEF OF STAFF">CHIEF OF STAFF</option>
                  <option value="PRESIDENTE">PRESIDENTE</option>
                  <option value="CONSULTOR PEDAGÓGICO">
                    CONSULTOR PEDAGÓGICO
                  </option>
                  <option value="COORDENADOR DE OLIMPIADAS">
                    COORDENADOR DE OLIMPIADAS
                  </option>
                  <option value="SUPERVISORA PEDAGÓGICA">
                    SUPERVISORA PEDAGÓGICA
                  </option>
                  <option value="GERENTE DE PRODUTOS E INOVAÇÃO">
                    GERENTE DE PRODUTOS E INOVAÇÃO
                  </option>
                  <option value="COORDENADORA ENSINO FUNDAMENTAL">
                    COORDENADORA ENSINO FUNDAMENTAL
                  </option>
                  <option value="GERENTE PRODUÇÃO">GERENTE PRODUÇÃO</option>
                  <option value="DIRETOR GERAL">DIRETOR GERAL</option>
                  <option value="ANALISTA EDUCACIONAL">
                    ANALISTA EDUCACIONAL
                  </option>
                  <option value="ESTAGIÁRIO">ESTAGIÁRIO</option>
                  <option value="CIO">CIO</option>
                  <option value="GERENTE DE EXPERIENCIAS DE APRENDIZAJE DIGITAL">
                    GERENTE DE EXPERIENCIAS DE APRENDIZAJE DIGITAL
                  </option>
                  <option value="DESIGNER SENIÔR">DESIGNER SENIÔR</option>
                  <option value="CHEFE DE GABINETE">CHEFE DE GABINETE</option>
                  <option value="DIRETOR DO ENSINO MÉDIO">
                    DIRETOR DO ENSINO MÉDIO
                  </option>
                  <option value="ASSESSORA PEDAGÓGICA">
                    ASSESSORA PEDAGÓGICA
                  </option>
                  <option value="RELAÇÕES PÚBLICAS">RELAÇÕES PÚBLICAS</option>
                  <option value="FORMADOR EDUCAÇÃO INFANTIL">
                    FORMADOR EDUCAÇÃO INFANTIL
                  </option>
                  <option value="COORDENADOR TÉCNICO-PEDAGÓGICO">
                    COORDENADOR TÉCNICO-PEDAGÓGICO
                  </option>
                  <option value="GERENTE DE CONTAS">GERENTE DE CONTAS</option>
                  <option value="CTO">CTO</option>
                  <option value="ANALISTA DE POLOS">ANALISTA DE POLOS</option>
                  <option value="SUPERVISORA DE POLOS">
                    SUPERVISORA DE POLOS
                  </option>
                  <option value="DIRETOR COMERCIAL">DIRETOR COMERCIAL</option>
                  <option value="Gerente comercial">Gerente comercial</option>
                  <option value="Gerente de producto">
                    Gerente de producto
                  </option>
                  <option value="Chefe de tecnología">
                    Chefe de tecnología
                  </option>
                  <option value="Gerente Geral">Gerente Geral</option>
                  <option value="chefe de contas área médica">
                    chefe de contas área médica
                  </option>
                  <option value="gerente geral">gerente geral</option>
                  <option value="Gerente de contas">Gerente de contas</option>
                  <option value="Gerente Geral LATAM">
                    Gerente Geral LATAM
                  </option>
                </select>
              </div>
            </div>
            <div className="_form_element _field-message _inline-style ">
              <label htmlFor="field[5]" className="_form-label">
                {`${labelsMessage}*`}
              </label>
              <div className="_field-wrapper">
                <textarea
                  id="field[5]"
                  name="field[5]"
                  placeholder={placeholdersMessage}
                  style={{ height: '149px' }}
                  required
                ></textarea>
              </div>
            </div>
            <div className="_button-wrapper _inline-style">
              <button
                id="_form_31_submit"
                className="btn blue md"
                type="submit"
              >
                {buttonsSend}
              </button>
            </div>
            <div className="_clear-element"></div>
          </div>
          <div className="_form-thank-you" style={{ display: 'none' }}></div>
        </form>
      </div>
    )
  }

  const renderActiveCampaignFormEN = () => {
    return (
      <div className="form-container">
        <form
          method="POST"
          action="https://medicalharbour86050.activehosted.com/proc.php"
          id="_form_32_"
          className="_form _form_32 _inline-form _inline-style _dark"
          noValidate
        >
          <input type="hidden" name="u" value="32" />
          <input type="hidden" name="f" value="32" />
          <input type="hidden" name="s" />
          <input type="hidden" name="c" value="0" />
          <input type="hidden" name="m" value="0" />
          <input type="hidden" name="act" value="sub" />
          <input type="hidden" name="v" value="2" />
          <input
            type="hidden"
            name="or"
            value="dfd749aee9d13ebe7b04d43099b73922"
          />
          <div className="_form-content">
            <div className="_form_element _field-department _inline-style ">
              <label htmlFor="field[117]" className="_form-label">
                {`${labelsDepartment}*`}
              </label>
              <div className="_field-wrapper">
                <select
                  name="field[117]"
                  id="field[117]"
                  defaultValue={'default'}
                  required
                >
                  <option value="default">{placeholdersDepartment}</option>
                  <option value="Commercial">Commercial</option>
                  <option value="Support">Support</option>
                  <option value="Others">Others</option>
                </select>
              </div>
            </div>
            <div className="_form_element _field-name _inline-style ">
              <label htmlFor="fullname" className="_form-label">
                {`${labelsFullName}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="fullname"
                  name="fullname"
                  placeholder={placeholdersName}
                  required
                />
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-institution _inline-style ">
              <label htmlFor="customer_account" className="_form-label">
                {`${labelsInstitution}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="customer_account"
                  name="customer_account"
                  placeholder={placeholdersInstitution}
                  required
                />
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-is-afya _inline-style ">
              <fieldset className="_form-fieldset">
                <legend className="_form-label">{`${labelsIsAfya}*`}</legend>
                <div className="flexbox">
                  <div className="_row _checkbox-radio">
                    <input
                      id="field_115Yes"
                      type="radio"
                      name="field[115]"
                      value="Yes"
                      required
                    />
                    <span>
                      <label htmlFor="field_115Yes">Yes</label>
                    </span>
                  </div>
                  <div className="_row _checkbox-radio">
                    <input
                      id="field_115No"
                      type="radio"
                      name="field[115]"
                      value="No"
                    />
                    <span>
                      <label htmlFor="field_115No">No</label>
                    </span>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="_form_element _field-email _inline-style ">
              <label htmlFor="email" className="_form-label">
                {`${labelsEmail}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="email"
                  name="email"
                  placeholder={placeholdersEmail}
                  required
                />
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-phone _inline-style">
              <label htmlFor="field[108]" className="_form-label">
                {`${labelsMobile}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="field[108]"
                  name="field[108]"
                  placeholder={placeholdersPhone}
                  required
                />
              </div>
            </div>
            <div className="_form_element _field-country _inline-style ">
              <label htmlFor="field[111]" className="_form-label">
                {`${labelsCountry}*`}
              </label>
              <div className="_field-wrapper">
                <select
                  name="field[111]"
                  id="field[111]"
                  defaultValue={'default'}
                  required
                >
                  <option value="default">{placeholdersCountry}</option>
                  <option value="Abkhazia">Abkhazia</option>
                  <option value="Afghanistan">Afghanistan</option>
                  <option value="Akrotiri and Dhekelia">
                    Akrotiri and Dhekelia
                  </option>
                  <option value="Albania">Albania</option>
                  <option value="Algeria">Algeria</option>
                  <option value="American Samoa">American Samoa</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Anguilla">Anguilla</option>
                  <option value="Antarctica">Antarctica</option>
                  <option value="Antigua and Barbuda">
                    Antigua and Barbuda
                  </option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Aruba">Aruba</option>
                  <option value="Ashmore and Cartier Islands">
                    Ashmore and Cartier Islands
                  </option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaijan">Azerbaijan</option>
                  <option value="Azores">Azores</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bahrain">Bahrain</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Belarus">Belarus</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Belize">Belize</option>
                  <option value="Benin">Benin</option>
                  <option value="Bermuda">Bermuda</option>
                  <option value="Bhutan">Bhutan</option>
                  <option value="Bolivia">Bolivia</option>
                  <option value="Bonaire">Bonaire</option>
                  <option value="Bosnia and Herzegovina">
                    Bosnia and Herzegovina
                  </option>
                  <option value="Botswana">Botswana</option>
                  <option value="Bouvet Island">Bouvet Island</option>
                  <option value="Brazil">Brazil</option>
                  <option value="British Indian Ocean Territory">
                    British Indian Ocean Territory
                  </option>
                  <option value="British Virgin Islands">
                    British Virgin Islands
                  </option>
                  <option value="Brunei">Brunei</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Cambodia">Cambodia</option>
                  <option value="Cameroon">Cameroon</option>
                  <option value="Canada">Canada</option>
                  <option value="Canary Islands">Canary Islands</option>
                  <option value="Cape Verde">Cape Verde</option>
                  <option value="Cayman Islands">Cayman Islands</option>
                  <option value="Central African Republic">
                    Central African Republic
                  </option>
                  <option value="Chad">Chad</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Christmas Island">Christmas Island</option>
                  <option value="Clipperton Island">Clipperton Island</option>
                  <option value="Cocos (Keeling) Islands">
                    Cocos (Keeling) Islands
                  </option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comoros">Comoros</option>
                  <option value="Congo-Brazzaville">Congo-Brazzaville</option>
                  <option value="Congo-Kinshasa">Congo-Kinshasa</option>
                  <option value="Cook Islands">Cook Islands</option>
                  <option value="Coral Sea Islands">Coral Sea Islands</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Croatia">Croatia</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Curaçao">Curaçao</option>
                  <option value="Cyprus">Cyprus</option>
                  <option value="Czech Republic">Czech Republic</option>
                  <option value="Denmark">Denmark</option>
                  <option value="Djibouti">Djibouti</option>
                  <option value="Dominica">Dominica</option>
                  <option value="Dominican Republic">Dominican Republic</option>
                  <option value="Dutch Saint Martin">Dutch Saint Martin</option>
                  <option value="East Timor">East Timor</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egypt">Egypt</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="England">England</option>
                  <option value="Equatorial Guinea">Equatorial Guinea</option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Estonia">Estonia</option>
                  <option value="Ethiopia">Ethiopia</option>
                  <option value="Falkland Islands">Falkland Islands</option>
                  <option value="Faroe Islands">Faroe Islands</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Finland">Finland</option>
                  <option value="France">France</option>
                  <option value="French Guyana">French Guyana</option>
                  <option value="French Polynesia">French Polynesia</option>
                  <option value="French Saint Martin">
                    French Saint Martin
                  </option>
                  <option value="French Southern and Antarctic Lands">
                    French Southern and Antarctic Lands
                  </option>
                  <option value="Gabon">Gabon</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Germany">Germany</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Gibraltar">Gibraltar</option>
                  <option value="Greece">Greece</option>
                  <option value="Greenland">Greenland</option>
                  <option value="Grenada">Grenada</option>
                  <option value="Guadeloupe">Guadeloupe</option>
                  <option value="Guam">Guam</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guernsey">Guernsey</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guinea-Bissau">Guinea-Bissau</option>
                  <option value="Guyana">Guyana</option>
                  <option value="Haiti">Haiti</option>
                  <option value="Heard Island and Mcdonald Islands">
                    Heard Island and Mcdonald Islands
                  </option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hong Kong">Hong Kong</option>
                  <option value="Hungary">Hungary</option>
                  <option value="Iceland">Iceland</option>
                  <option value="India">India</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="Iran">Iran</option>
                  <option value="Iraq">Iraq</option>
                  <option value="Ireland">Ireland</option>
                  <option value="Isle of Man">Isle of Man</option>
                  <option value="Israel">Israel</option>
                  <option value="Italy">Italy</option>
                  <option value="Ivory Coast">Ivory Coast</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Jan Mayen">Jan Mayen</option>
                  <option value="Japan">Japan</option>
                  <option value="Jersey">Jersey</option>
                  <option value="Jordan">Jordan</option>
                  <option value="Kazakhstan">Kazakhstan</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Kosovo">Kosovo</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                  <option value="Laos">Laos</option>
                  <option value="Latvia">Latvia</option>
                  <option value="Lebanon">Lebanon</option>
                  <option value="Lesotho">Lesotho</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libya">Libya</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lithuania">Lithuania</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Macau">Macau</option>
                  <option value="Macedonia">Macedonia</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Madeira">Madeira</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="Maldives">Maldives</option>
                  <option value="Mali">Mali</option>
                  <option value="Malta">Malta</option>
                  <option value="Marshall Islands">Marshall Islands</option>
                  <option value="Martinique">Martinique</option>
                  <option value="Mauritania">Mauritania</option>
                  <option value="Mauritius">Mauritius</option>
                  <option value="Mayotte">Mayotte</option>
                  <option value="Mexico">Mexico</option>
                  <option value="Micronesia">Micronesia</option>
                  <option value="Moldova">Moldova</option>
                  <option value="Monaco">Monaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Montenegro">Montenegro</option>
                  <option value="Montserrat">Montserrat</option>
                  <option value="Morocco">Morocco</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Myanmar">Myanmar</option>
                  <option value="Nagorno-Karabakh">Nagorno-Karabakh</option>
                  <option value="Namibia">Namibia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Navassa Island">Navassa Island</option>
                  <option value="Nepal">Nepal</option>
                  <option value="New Caledonia">New Caledonia</option>
                  <option value="New Zealand">New Zealand</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Niger">Niger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="Niue">Niue</option>
                  <option value="Norfolk Island">Norfolk Island</option>
                  <option value="North Cyprus">North Cyprus</option>
                  <option value="North Korea">North Korea</option>
                  <option value="Northern Ireland">Northern Ireland</option>
                  <option value="Northern Mariana Islands">
                    Northern Mariana Islands
                  </option>
                  <option value="Norway">Norway</option>
                  <option value="Oman">Oman</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="Palau">Palau</option>
                  <option value="Palestine">Palestine</option>
                  <option value="Panama">Panama</option>
                  <option value="Papua New Guinea">Papua New Guinea</option>
                  <option value="Paracel Islands">Paracel Islands</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Peru">Peru</option>
                  <option value="Philippines">Philippines</option>
                  <option value="Pitcairn Islands">Pitcairn Islands</option>
                  <option value="Poland">Poland</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Puerto Rico">Puerto Rico</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Réunion">Réunion</option>
                  <option value="Romania">Romania</option>
                  <option value="Russia">Russia</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="Saba">Saba</option>
                  <option value="Saint Bartholomew">Saint Bartholomew</option>
                  <option value="Saint Eustace">Saint Eustace</option>
                  <option value="Saint Helena">Saint Helena</option>
                  <option value="Saint Kitts and Nevis">
                    Saint Kitts and Nevis
                  </option>
                  <option value="Saint Lucia">Saint Lucia</option>
                  <option value="Saint Pierre and Miquelon">
                    Saint Pierre and Miquelon
                  </option>
                  <option value="Saint Thomas and Prince">
                    Saint Thomas and Prince
                  </option>
                  <option value="Saint Vincent And The Grenadines">
                    Saint Vincent And The Grenadines
                  </option>
                  <option value="Samoa">Samoa</option>
                  <option value="San Marino">San Marino</option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="Scotland">Scotland</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Serbia">Serbia</option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra Leone">Sierra Leone</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Slovakia">Slovakia</option>
                  <option value="Slovenia">Slovenia</option>
                  <option value="Solomon Islands">Solomon Islands</option>
                  <option value="Somalia">Somalia</option>
                  <option value="Somaliland">Somaliland</option>
                  <option value="South Africa">South Africa</option>
                  <option value="South Georgia">South Georgia</option>
                  <option value="South Korea">South Korea</option>
                  <option value="South Ossetia">South Ossetia</option>
                  <option value="South Sudan">South Sudan</option>
                  <option value="Spain">Spain</option>
                  <option value="Spratly Islands">Spratly Islands</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="Sudan">Sudan</option>
                  <option value="Suriname">Suriname</option>
                  <option value="Swaziland">Swaziland</option>
                  <option value="Sweden">Sweden</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="Syria">Syria</option>
                  <option value="Taiwan">Taiwan</option>
                  <option value="Tajikistan">Tajikistan</option>
                  <option value="Tanzania">Tanzania</option>
                  <option value="Thailand">Thailand</option>
                  <option value="The Netherlands">The Netherlands</option>
                  <option value="Togo">Togo</option>
                  <option value="Tokelau">Tokelau</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Transnistria">Transnistria</option>
                  <option value="Trinidad and Tobago">
                    Trinidad and Tobago
                  </option>
                  <option value="Tunisia">Tunisia</option>
                  <option value="Turkey">Turkey</option>
                  <option value="Turkmenistan">Turkmenistan</option>
                  <option value="Turks And Caicos Islands">
                    Turks And Caicos Islands
                  </option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Ukraine">Ukraine</option>
                  <option value="United Arab Emirates">
                    United Arab Emirates
                  </option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="United States of America">
                    United States of America
                  </option>
                  <option value="United States Virgin Islands">
                    United States Virgin Islands
                  </option>
                  <option value="Uruguay">Uruguay</option>
                  <option value="Uzbekistan">Uzbekistan</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Vatican City">Vatican City</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Vietnam">Vietnam</option>
                  <option value="Wake Island">Wake Island</option>
                  <option value="Wales">Wales</option>
                  <option value="Wallis and Futuna">Wallis and Futuna</option>
                  <option value="Western Sahara">Western Sahara</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zanzibar">Zanzibar</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                </select>
              </div>
            </div>
            <div className="_form_element _field-profession _inline-style ">
              <label htmlFor="field[69]" className="_form-label">
                {`${labelsProfession}*`}
              </label>
              <div className="_field-wrapper">
                <select
                  name="field[69]"
                  id="field[69]"
                  defaultValue={'default'}
                  required
                >
                  <option value="default">{placeholdersProfession}</option>
                  <option value="Forensic Lawyer">Forensic Lawyer</option>
                  <option value="Course coordinator">Course coordinator</option>
                  <option value="Dean">Dean</option>
                  <option value="Dentist">Dentist</option>
                  <option value="Student - Medicine">Student - Medicine</option>
                  <option value="Student - Veterinarian">
                    Student - Veterinarian
                  </option>
                  <option value="Student - Another course in the health area">
                    Student - Another course in the health area
                  </option>
                  <option value="Doctor - Cardiologist">
                    Doctor - Cardiologist
                  </option>
                  <option value="Surgeon">Surgeon</option>
                  <option value="General practitioner">
                    General practitioner
                  </option>
                  <option value="Doctor - Neurologist">
                    Doctor - Neurologist
                  </option>
                  <option value="Doctor - Orthopedist">
                    Doctor - Orthopedist
                  </option>
                  <option value="Radiologist doctor">Radiologist doctor</option>
                  <option value="Resident doctor">Resident doctor</option>
                  <option value="Doctor - Other medical specialty">
                    Doctor - Other medical specialty
                  </option>
                  <option value="Researcher">Researcher</option>
                  <option value="Teacher">Teacher</option>
                  <option value="TI Provider">TI Provider</option>
                  <option value="Radiology Technician">
                    Radiology Technician
                  </option>
                  <option value="Vet">Vet</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            <div className="_form_element _field-message _inline-style ">
              <label htmlFor="field[5]" className="_form-label">
                {`${labelsMessage}*`}
              </label>
              <div className="_field-wrapper">
                <textarea
                  id="field[5]"
                  name="field[5]"
                  placeholder={placeholdersMessage}
                  style={{ height: '149px' }}
                  required
                ></textarea>
              </div>
            </div>
            <div className="_button-wrapper _inline-style">
              <button
                id="_form_32_submit"
                className="btn blue md"
                type="submit"
              >
                {buttonsSend}
              </button>
            </div>
            <div className="_clear-element"></div>
          </div>
          <div className="_form-thank-you" style={{ display: 'none' }}></div>
        </form>
      </div>
    )
  }

  const renderActiveCampaignFormES = () => {
    return (
      <div className="form-container">
        <form
          method="POST"
          action="https://medicalharbour86050.activehosted.com/proc.php"
          id="_form_33_"
          className="_form _form_33 _inline-form _inline-style _dark"
          noValidate
        >
          <input type="hidden" name="u" value="33" />
          <input type="hidden" name="f" value="33" />
          <input type="hidden" name="s" />
          <input type="hidden" name="c" value="0" />
          <input type="hidden" name="m" value="0" />
          <input type="hidden" name="act" value="sub" />
          <input type="hidden" name="v" value="2" />
          <input
            type="hidden"
            name="or"
            value="c58ac51d639f9cc160b2d3bce94244a"
          />
          <div className="_form-content">
            <div className="_form_element _field-department _inline-style ">
              <label htmlFor="field[116]" className="_form-label">
                {`${labelsDepartment}*`}
              </label>
              <div className="_field-wrapper">
                <select
                  name="field[116]"
                  id="field[116]"
                  defaultValue={'default'}
                  required
                >
                  <option value="default">{placeholdersDepartment}</option>
                  <option value="Comercial">Comercial</option>
                  <option value="Soporte">Soporte</option>
                  <option value="Otros">Otros</option>
                </select>
              </div>
            </div>
            <div className="_form_element _field-name _inline-style ">
              <label htmlFor="fullname" className="_form-label">
                {`${labelsFullName}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="fullname"
                  name="fullname"
                  placeholder={placeholdersName}
                  required
                />
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-institution _inline-style ">
              <label htmlFor="customer_account" className="_form-label">
                {`${labelsInstitution}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="customer_account"
                  name="customer_account"
                  placeholder={placeholdersInstitution}
                  required
                />
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-is-afya _inline-style ">
              <fieldset className="_form-fieldset">
                <legend className="_form-label">{`${labelsIsAfya}*`}</legend>
                <div className="flexbox">
                  <div className="_row _checkbox-radio">
                    <input
                      id="field_114Sí"
                      type="radio"
                      name="field[114]"
                      value="Sí"
                      required
                    />
                    <span>
                      <label htmlFor="field_114Sí">Sí</label>
                    </span>
                  </div>
                  <div className="_row _checkbox-radio">
                    <input
                      id="field_114No"
                      type="radio"
                      name="field[114]"
                      value="No"
                    />
                    <span>
                      <label htmlFor="field_114No">No</label>
                    </span>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="_form_element _field-email _inline-style ">
              <label htmlFor="email" className="_form-label">
                {`${labelsEmail}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="email"
                  name="email"
                  placeholder={placeholdersEmail}
                  required
                />
              </div>
              {/* <!--  This STARTS the Account Custom Fields section  --> */}
            </div>
            <div className="_form_element _field-phone _inline-style">
              <label htmlFor="field[108]" className="_form-label">
                {`${labelsMobile}*`}
              </label>
              <div className="_field-wrapper">
                <input
                  type="text"
                  id="field[108]"
                  name="field[108]"
                  placeholder={placeholdersPhone}
                  required
                />
              </div>
            </div>
            <div className="_form_element _field-country _inline-style ">
              <label htmlFor="field[110]" className="_form-label">
                {`${labelsCountry}*`}
              </label>
              <div className="_field-wrapper">
                <select
                  name="field[110]"
                  id="field[110]"
                  defaultValue={'default'}
                  required
                >
                  <option value="default">{placeholdersCountry}</option>
                  <option value="Abjasia">Abjasia</option>
                  <option value="Acrotiri y Deceleia">
                    Acrotiri y Deceleia
                  </option>
                  <option value="Afganistán">Afganistán</option>
                  <option value="Albania">Albania</option>
                  <option value="Alemania">Alemania</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Anguila">Anguila</option>
                  <option value="Antigua y Barbuda">Antigua y Barbuda</option>
                  <option value="Arabia Saudita">Arabia Saudita</option>
                  <option value="Argelia">Argelia</option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Aruba">Aruba</option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaiyán">Azerbaiyán</option>
                  <option value="Azores">Azores</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Baréin">Baréin</option>
                  <option value="Bélgica">Bélgica</option>
                  <option value="Belice">Belice</option>
                  <option value="Benín">Benín</option>
                  <option value="Bielorrusia">Bielorrusia</option>
                  <option value="Birmania">Birmania</option>
                  <option value="Bolivia">Bolivia</option>
                  <option value="Bonaire">Bonaire</option>
                  <option value="Bosnia y Herzegovina">
                    Bosnia y Herzegovina
                  </option>
                  <option value="Botsuana">Botsuana</option>
                  <option value="Brasil">Brasil</option>
                  <option value="Brunéi">Brunéi</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Bután">Bután</option>
                  <option value="Cabo Verde">Cabo Verde</option>
                  <option value="Camboya">Camboya</option>
                  <option value="Camerún">Camerún</option>
                  <option value="Canadá">Canadá</option>
                  <option value="Canarios">Canarios</option>
                  <option value="Chad">Chad</option>
                  <option value="Chile">Chile</option>
                  <option value="Chipre">Chipre</option>
                  <option value="Chipre Del Norte">Chipre Del Norte</option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comoras">Comoras</option>
                  <option value="Corea Del Norte">Corea Del Norte</option>
                  <option value="Corea Del Sur">Corea Del Sur</option>
                  <option value="Costa De Marfil">Costa De Marfil</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Croacia">Croacia</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Curazao">Curazao</option>
                  <option value="Dinamarca">Dinamarca</option>
                  <option value="Dominicana">Dominicana</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egipto">Egipto</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Emiratos Árabes Unidos">
                    Emiratos Árabes Unidos
                  </option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Escocia">Escocia</option>
                  <option value="Eslovaquia">Eslovaquia</option>
                  <option value="Eslovenia">Eslovenia</option>
                  <option value="España">España</option>
                  <option value="Estados Unidos de America">
                    Estados Unidos de America
                  </option>
                  <option value="Estonia">Estonia</option>
                  <option value="Etiopía">Etiopía</option>
                  <option value="Feroe">Feroe</option>
                  <option value="Filipinas">Filipinas</option>
                  <option value="Finlandia">Finlandia</option>
                  <option value="Fiyi">Fiyi</option>
                  <option value="Francia">Francia</option>
                  <option value="Gabón">Gabón</option>
                  <option value="Gales">Gales</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Georgia Del Sur y Sandwich Del Sur">
                    Georgia Del Sur y Sandwich Del Sur
                  </option>
                  <option value="Ghana">Ghana</option>
                  <option value="Gibraltar">Gibraltar</option>
                  <option value="Granada">Granada</option>
                  <option value="Grecia">Grecia</option>
                  <option value="Groenlandia">Groenlandia</option>
                  <option value="Guadalupe">Guadalupe</option>
                  <option value="Guam">Guam</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guayana">Guayana</option>
                  <option value="Guernesey">Guernesey</option>
                  <option value="Guiana Francesa">Guiana Francesa</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guinea Ecuatorial">Guinea Ecuatorial</option>
                  <option value="Guinea-Bisáu">Guinea-Bisáu</option>
                  <option value="Haití">Haití</option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hong Kong">Hong Kong</option>
                  <option value="Hungría">Hungría</option>
                  <option value="India">India</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="Inglaterra">Inglaterra</option>
                  <option value="Irak">Irak</option>
                  <option value="Irlanda">Irlanda</option>
                  <option value="Irlanda Del Norte">Irlanda Del Norte</option>
                  <option value="Isla Bouvet">Isla Bouvet</option>
                  <option value="Isla Clipperton">Isla Clipperton</option>
                  <option value="Isla De La Madera">Isla De La Madera</option>
                  <option value="Isla De Navassa">Isla De Navassa</option>
                  <option value="Isla De Navidad">Isla De Navidad</option>
                  <option value="Isla Del Hombre">Isla Del Hombre</option>
                  <option value="Isla Jan Mayen">Isla Jan Mayen</option>
                  <option value="Isla Norfolk">Isla Norfolk</option>
                  <option value="Isla Wake">Isla Wake</option>
                  <option value="Islandia">Islandia</option>
                  <option value="Islas Ashmore y Cartier">
                    Islas Ashmore y Cartier
                  </option>
                  <option value="Islas Bermudas">Islas Bermudas</option>
                  <option value="Islas Caimán">Islas Caimán</option>
                  <option value="Islas Cocos">Islas Cocos</option>
                  <option value="Islas Cook">Islas Cook</option>
                  <option value="Islas Del Mar De Coral">
                    Islas Del Mar De Coral
                  </option>
                  <option value="Islas Heard Y Mcdonald">
                    Islas Heard Y Mcdonald
                  </option>
                  <option value="Islas Malvinas">Islas Malvinas</option>
                  <option value="Islas Marshall">Islas Marshall</option>
                  <option value="Islas Paracel">Islas Paracel</option>
                  <option value="Islas Pitcairn">Islas Pitcairn</option>
                  <option value="Islas Salomón">Islas Salomón</option>
                  <option value="Islas Spratly">Islas Spratly</option>
                  <option value="Islas Turcas y Caicos">
                    Islas Turcas y Caicos
                  </option>
                  <option value="Islas Vírgenes Británicas">
                    Islas Vírgenes Británicas
                  </option>
                  <option value="Islas Vírgenes De Ee.Uu">
                    Islas Vírgenes De Ee.Uu
                  </option>
                  <option value="Israel">Israel</option>
                  <option value="Italia">Italia</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japón">Japón</option>
                  <option value="Jersey">Jersey</option>
                  <option value="Jordán">Jordán</option>
                  <option value="Katar">Katar</option>
                  <option value="Kazajistán">Kazajistán</option>
                  <option value="Kenia">Kenia</option>
                  <option value="Kirguistán">Kirguistán</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Kosovo">Kosovo</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Laos">Laos</option>
                  <option value="Lesoto">Lesoto</option>
                  <option value="Letonia">Letonia</option>
                  <option value="Líbano">Líbano</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libia">Libia</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lituania">Lituania</option>
                  <option value="Luxemburgo">Luxemburgo</option>
                  <option value="Macao">Macao</option>
                  <option value="Macedonia Del Norte">
                    Macedonia Del Norte
                  </option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malasia">Malasia</option>
                  <option value="Malaui">Malaui</option>
                  <option value="Maldivas">Maldivas</option>
                  <option value="Malí">Malí</option>
                  <option value="Malta">Malta</option>
                  <option value="Marianas Del Norte">Marianas Del Norte</option>
                  <option value="Marruecos">Marruecos</option>
                  <option value="Martinica">Martinica</option>
                  <option value="Mauricio">Mauricio</option>
                  <option value="Mauritania">Mauritania</option>
                  <option value="Mayonesa">Mayonesa</option>
                  <option value="México">México</option>
                  <option value="Micronesia">Micronesia</option>
                  <option value="Moldavia">Moldavia</option>
                  <option value="Mónaco">Mónaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Monserrate">Monserrate</option>
                  <option value="Montenegro">Montenegro</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Nagorno-Karabaj">Nagorno-Karabaj</option>
                  <option value="Namibia">Namibia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Níger">Níger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="Niue">Niue</option>
                  <option value="Noruega">Noruega</option>
                  <option value="Nueva Caledonia">Nueva Caledonia</option>
                  <option value="Nueva Zelanda">Nueva Zelanda</option>
                  <option value="Omán">Omán</option>
                  <option value="Osetia Del Sur">Osetia Del Sur</option>
                  <option value="Países Bajos">Países Bajos</option>
                  <option value="Pakistán">Pakistán</option>
                  <option value="Palaos">Palaos</option>
                  <option value="Palestina">Palestina</option>
                  <option value="Panamá">Panamá</option>
                  <option value="Papúa Nueva Guinea">Papúa Nueva Guinea</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Pavo">Pavo</option>
                  <option value="Perú">Perú</option>
                  <option value="Polinesio Francés">Polinesio Francés</option>
                  <option value="Polonia">Polonia</option>
                  <option value="Porcelana">Porcelana</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Puerto Rico">Puerto Rico</option>
                  <option value="Reino Unido">Reino Unido</option>
                  <option value="República Centroafricana">
                    República Centroafricana
                  </option>
                  <option value="República Checa">República Checa</option>
                  <option value="República Del Congo">
                    República Del Congo
                  </option>
                  <option value="República Democrática Del Congo">
                    República Democrática Del Congo
                  </option>
                  <option value="República Dominicana">
                    República Dominicana
                  </option>
                  <option value="Reunión">Reunión</option>
                  <option value="Ruanda">Ruanda</option>
                  <option value="Rumania">Rumania</option>
                  <option value="Rusia">Rusia</option>
                  <option value="Saba">Saba</option>
                  <option value="Sahara Occidental">Sahara Occidental</option>
                  <option value="Samoa">Samoa</option>
                  <option value="Samoa Americana">Samoa Americana</option>
                  <option value="San Bartolomé">San Bartolomé</option>
                  <option value="San Cristóbal y Nieves">
                    San Cristóbal y Nieves
                  </option>
                  <option value="San Eustaquio">San Eustaquio</option>
                  <option value="San Marino">San Marino</option>
                  <option value="San Martin Frances">San Martin Frances</option>
                  <option value="San Martín Holandés">
                    San Martín Holandés
                  </option>
                  <option value="San Pedro y Miquelón">
                    San Pedro y Miquelón
                  </option>
                  <option value="San Tome y Principe">
                    San Tome y Principe
                  </option>
                  <option value="San Vicente y Las Granadinas">
                    San Vicente y Las Granadinas
                  </option>
                  <option value="Santa Helena">Santa Helena</option>
                  <option value="Santa Lucía">Santa Lucía</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Serbia">Serbia</option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra Leona">Sierra Leona</option>
                  <option value="Singapur">Singapur</option>
                  <option value="Siria">Siria</option>
                  <option value="Somalia">Somalia</option>
                  <option value="Somalilandia">Somalilandia</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="Suazilandia">Suazilandia</option>
                  <option value="Sudáfrica">Sudáfrica</option>
                  <option value="Sudán">Sudán</option>
                  <option value="Sudán Del Sur">Sudán Del Sur</option>
                  <option value="Suecia">Suecia</option>
                  <option value="Suiza">Suiza</option>
                  <option value="Surinam">Surinam</option>
                  <option value="Tailandia">Tailandia</option>
                  <option value="Taiwán">Taiwán</option>
                  <option value="Tanzania">Tanzania</option>
                  <option value="Tayikistán">Tayikistán</option>
                  <option value="Territorio Británico Del Océano Índico">
                    Territorio Británico Del Océano Índico
                  </option>
                  <option value="Territorios Franceses Del Sur">
                    Territorios Franceses Del Sur
                  </option>
                  <option value="Timor Oriental">Timor Oriental</option>
                  <option value="Togo">Togo</option>
                  <option value="Tokelau">Tokelau</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Transnistria">Transnistria</option>
                  <option value="Trinidad y Tobago">Trinidad y Tobago</option>
                  <option value="Túnez">Túnez</option>
                  <option value="Turkmenistán">Turkmenistán</option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Ucrania">Ucrania</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Uruguay">Uruguay</option>
                  <option value="Uzbekistán">Uzbekistán</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Vaticano">Vaticano</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Vietnam">Vietnam</option>
                  <option value="Voluntad">Voluntad</option>
                  <option value="Wallis Y Futuna">Wallis Y Futuna</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Yibuti">Yibuti</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zanzíbar">Zanzíbar</option>
                  <option value="Zimbabue">Zimbabue</option>
                </select>
              </div>
            </div>
            <div className="_form_element _field-profession _inline-style ">
              <label htmlFor="field[62]" className="_form-label">
                {`${labelsProfession}*`}
              </label>
              <div className="_field-wrapper">
                <select
                  name="field[62]"
                  id="field[62]"
                  defaultValue={'default'}
                  required
                >
                  <option value="default">{placeholdersProfession}</option>
                  <option value="Abogado Forense">Abogado Forense</option>
                  <option value="Coordinador de curso">
                    Coordinador de curso
                  </option>
                  <option value="Decano">Decano</option>
                  <option value="Estudiante - Medicina">
                    Estudiante - Medicina
                  </option>
                  <option value="Estudiante - Veterinária">
                    Estudiante - Veterinária
                  </option>
                  <option value="Estudiante - Otro curso en la área de la salud">
                    Estudiante - Otro curso en la área de la salud
                  </option>
                  <option value="Médico - Cardiólogo">
                    Médico - Cardiólogo
                  </option>
                  <option value="Cirujano">Cirujano</option>
                  <option value="Médico General">Médico General</option>
                  <option value="Médico - Neurólogo">Médico - Neurólogo</option>
                  <option value="Médico - Ortopedista">
                    Médico - Ortopedista
                  </option>
                  <option value="Médico Radiólogo">Médico Radiólogo</option>
                  <option value="Médico Residente">Médico Residente</option>
                  <option value="Médico - Otra Especialidad Médica">
                    Médico - Otra Especialidad Médica
                  </option>
                  <option value="Investigador">Investigador</option>
                  <option value="Profesor">Profesor</option>
                  <option value="Profesional de TI">Profesional de TI</option>
                  <option value="Técnico em Radiología">
                    Técnico em Radiología
                  </option>
                  <option value="Veterinario">Veterinario</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>
            </div>
            <div className="_form_element _field-message _inline-style ">
              <label htmlFor="field[5]" className="_form-label">
                {`${labelsMessage}*`}
              </label>
              <div className="_field-wrapper">
                <textarea
                  id="field[5]"
                  name="field[5]"
                  placeholder={placeholdersMessage}
                  style={{ height: '149px' }}
                  required
                ></textarea>
              </div>
            </div>
            <div className="_button-wrapper _inline-style">
              <button
                id="_form_33_submit"
                className="btn blue md"
                type="submit"
              >
                {buttonsSend}
              </button>
            </div>
            <div className="_clear-element"></div>
          </div>
          <div className="_form-thank-you" style={{ display: 'none' }}></div>
        </form>
      </div>
    )
  }

  const hideForm = () => {
    if (!formID) return
    document.getElementById(formID).parentElement.classList.remove('active')
  }

  const showForm = () => {
    if (!formID) return
    document.getElementById(formID).parentElement.classList.add('active')
  }

  return (
    <Public>
      <SEO title={pageTitle} />
      <HeaderUnsigned pageName="contact" />
      <ContactContainer>
        {windowSize.width > 900 ? (
          <Desktop className="flexbox v-centered h-spaced">
            <TextContainer>
              <h1>{subtitlesSales}</h1>
              <a
                href={whatsAppLink}
                target="_blank"
                rel="noopener noreferrer"
                id="btn_whatsapp"
                className="flexbox v-centered"
              >
                <img
                  src={ASSET_PATHS.icon_whatsapp}
                  alt=""
                  className="material-icons"
                />
                <span className="contact">{labelsContactWhats}</span>
              </a>
              <EmailButton id="contacts" iconOutline={false} />
            </TextContainer>
            {renderActiveCampaignFormPT()}
            {renderActiveCampaignFormEN()}
            {renderActiveCampaignFormES()}
          </Desktop>
        ) : (
          <Mobile>
            <h1>{subtitlesSales}</h1>
            {renderActiveCampaignFormPT()}
            {renderActiveCampaignFormEN()}
            {renderActiveCampaignFormES()}
            <TextContainer>
              <div className="flexbox v-centered h-around">
                <a
                  href={whatsAppLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  id="btn_whatsapp"
                >
                  <div>
                    <img
                      src={ASSET_PATHS.icon_whatsapp}
                      alt=""
                      className="material-icons"
                    />
                  </div>
                  <p className="contact">{labelsContactWhats}</p>
                </a>
              </div>

              <div>
                <div>
                  <span className="material-icons-round">email</span>
                </div>
                <p className="contact">{labelsContactEmail}</p>
              </div>
            </TextContainer>
          </Mobile>
        )}
      </ContactContainer>
      <FooterUnsigned />
    </Public>
  )
}

export default Contact
